var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgQuote = function SvgQuote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 28h16.263l3.193-13.592h-8.88l.4-1.903c.897-4.35 3.99-6.706 9.677-6.706h.798L22.848 0h-.798C11.773 0 5.587 4.35 3.592 12.777zm21.152 0h16.263l3.193-13.592h-8.88l.399-1.903c.898-4.35 3.99-6.706 9.678-6.706h.798L44 0h-.798C32.925 0 26.739 4.35 24.744 12.777z"
  })));
};
export default SvgQuote;